
// src/web/components/diary-actions.jsx

import React from 'react'
import { themr } from 'react-css-themr'
import classnames from 'classnames'
import { translate } from 'react-i18next'
import connect from '../../connects/diary-actions'
import diaryTheme from './themes/diary.css'
import diaryLikeTheme from './themes/diary-like.css'
import Tooltip from 'react-toolbox/lib/tooltip'
import {
  Button,
} from 'react-toolbox/lib/button'
import {
  CardText,
} from 'react-toolbox/lib/card'
import FontIcon from 'react-toolbox/lib/font_icon'
import ReactDOM from 'react-dom'
import debounce from 'lodash/debounce'
import find from 'lodash/find'
import map from 'lodash/map'
import emoji from '../../native/assets/emoji'
import diaryButtonTheme from './themes/diary-form-button.css'

const TooltipButton = Tooltip(Button)

const buttonStyle = {
  minWidth: '0',
  padding: '0 8px',
  height: '36px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '0 0 auto'
};

const iconStyle = {
  marginRight: '4px',
  width: '20px',
  height: '20px',
  display: 'flex',
  alignItems: 'center'
};

@themr('Diary', diaryTheme)
class DiaryActions extends React.Component {
  constructor(props) {
    super(props);
    this.changeWindowDisplay = this.changeWindowDisplay.bind(this);
    // issues/5434への対応コードを改善
    this.debounce = debounce(this.changeWindowDisplay, 200, {
      leading: false,  // 最初のイベントをスキップ
      trailing: true,  // 最後のイベントを実行
      maxWait: 1000
    });
    // Refs for DOM elements
    this.containerRef = React.createRef();
    this.likeFieldRef = React.createRef();
    this.reactionFieldRef = React.createRef();
    // Track mounted state
    this._isMounted = false;
  }
  componentDidMount() {
    this._isMounted = true;
    // issues/5434への対応コードを改善
    // RAF内でDOM操作を行い、レイアウトスラッシングを防ぐ
    requestAnimationFrame(() => {
      if (this._isMounted && this.containerRef.current) {
        this.props.updateUI({ innerWidth: this.containerRef.current.clientWidth });
      }
    });
    window.addEventListener('resize', this.debounce);
  }

  componentWillUnmount() {
    this._isMounted = false;
    // issues/5434への対応コードを改善
    if (this.debounce) {
      this.debounce.cancel();  // debounceのキャンセル
      window.removeEventListener('resize', this.debounce);
    }
  }

  changeWindowDisplay = () => {
    if (this._isMounted && this.containerRef.current) {
      this.props.updateUI({ innerWidth: this.containerRef.current.clientWidth });
    }
  }

  reactionMouseOver = () => {
    if(this.props.ui.timer){
      this.props.updateUI({ timer: false })
      clearTimeout( this.setMouseOutTimer )
    }else{
      this.setMouseOverTimer = setTimeout(() => this.props.updateUI({ reactionFocus: true }), 500)
    }
  }
  
  reactionMouseOut = (e) => {
    if (!this._isMounted) return;
    
    const likeFieldOut = this.likeFieldRef.current;
    const reactionFieldOut = this.reactionFieldRef.current;
    
    /* 一定時間、いいねボタンとリアクションボタン上にマウスが当たっていない場合はsetTimeOutでリアクションボタンを非表示にする*/
    if(reactionFieldOut != null && likeFieldOut && !likeFieldOut.contains(e.relatedTarget) && !reactionFieldOut.contains(e.relatedTarget)){
      this.props.updateUI({ timer: true })
      this.setMouseOutTimer = setTimeout(()=> {
        if(this._isMounted && this.props.ui.timer){
          this.props.updateUI({ reactionFocus: false, timer: false })
        }
      },800)
    }else {
      /* いいねボタンにマウスが当たってすぐに要素を抜けるとreactionFieldOutがnullで返ってくるため、nullの場合はMounceOverで設定したSetTimeOutを無効にする */
      clearTimeout( this.setMouseOverTimer )
    }
  }

  onClick = (like_type) => {
    this.props.onReaction(like_type)
    this.props.updateUI({ reactionFocus: false })
  }

  onLike = ()=> {
    if (!this.props.ui.disableLike) {
      this.props.updateUI({ disableLike: true })
      this.props.onLike()
      setTimeout(()=> this.props.updateUI({ disableLike: false }), 1000)
    }
    /* reactionFocusがtrue状態でいいねボタンを押下した場合はfalseにしてreactionFieldを非表示にする */
    this.props.ui.reactionFocus && this.props.updateUI({ reactionFocus: false })
  }

  render() {
    const {
      t,
      ui,
      updateUI,
      like,
      onLike,
      onReaction,
      onComment,
      onStamp,
      theme,
      isComment,
      likeConfig,
      onOpenReview,
      isFetching,
      isReviewEnable,
      isReviewButtonDisplay = true
    } = this.props

    return (
    <div ref={this.containerRef} style={{ position: 'relative'}}>
      {!isComment && <CardText theme={theme} className="actions">
        <div ref={this.likeFieldRef} onMouseOver={(!this.props.ui.reactionFocus || this.props.ui.timer) && this.reactionMouseOver} onMouseOut={this.reactionMouseOut}>
          {this.props.ui.reactionFocus &&
            <div ref={this.reactionFieldRef} theme={theme} className="reactionField">
              {likeConfig && map(likeConfig, (item, type) =>
                <TooltipButton theme={diaryLikeTheme} className="reaction" neutral={false} ripple={false}
                  tooltipPosition="top"
                  tooltip={item.label}
                  icon={<img className={this.props.ui.innerWidth >= 500 ? diaryLikeTheme.image : diaryLikeTheme.minImage} src={emoji[item.icon.replace('\\u','')]}  />}
                  onClick={() => this.onClick(type)}/>)}
            </div>}
          <Button
            theme={theme}
            className="diary"
            neutral={false}
            icon={like ? 
              <img 
                src={likeConfig && emoji[likeConfig[like.like_type].icon.replace('\\u','')]} 
                style={iconStyle} 
              /> : 
              <FontIcon value='favorite_border' style={{ ...iconStyle, color: 'gray'}}/>
            }
            onClick={this.onLike}
            style={{ ...buttonStyle, color: like && 'red' || 'gray' }}
            label={like ? likeConfig && likeConfig[like.like_type].label : t('label:いいね')}
          />
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Button
            theme={theme}
            className="diary"
            neutral={false}
            icon={<FontIcon value='comment' style={{ ...iconStyle, color: 'blue' }} />}
            onClick={onComment}
            style={buttonStyle}
            label={t('label:コメント')}
          />
          <Button 
            theme={theme}
            className="diary"
            neutral={false}
            icon={<FontIcon value='tag_faces' style={{ ...iconStyle, color: 'orange' }} />}
            onClick={onStamp}
            style={buttonStyle}
            label={t('label:スタンプ')}
          />
          {!isComment && isReviewEnable && isReviewButtonDisplay &&
            <Button 
              disabled={isFetching}
              theme={theme} 
              className="diary"
              neutral={false}
              icon={<FontIcon value='auto_awesome' style={{ ...iconStyle, color: 'purple' }} />}
              onClick={onOpenReview}
              style={buttonStyle}
              label={isFetching ? 'AIレビュー(処理中...)' : 'AIレビュー'}
            />
          }
        </div>
      </CardText>}
      {isComment && <CardText theme={theme} className="subactions">
      <div ref={this.likeFieldRef} onMouseOver={(!this.props.ui.reactionFocus || this.props.ui.timer) && this.reactionMouseOver} onMouseOut={this.reactionMouseOut}>
      {this.props.ui.reactionFocus &&
        <div ref={this.reactionFieldRef} theme={theme} className="reactionCommentField">
          {likeConfig && map(likeConfig, (item, type) =>
            <TooltipButton theme={diaryLikeTheme} className={this.props.ui.innerWidth >= 500 ? "reaction" : "ShrinkReaction"} neutral={false} ripple={false}
              tooltipPosition="top"
              tooltip={item.label}
              icon={<img className={this.props.ui.innerWidth >= 500 ? diaryLikeTheme.image : diaryLikeTheme.minImage} src={emoji[item.icon.replace('\\u','')]} />}
              onClick={() => this.onClick(type)}/>)}
        </div>}
        <Button theme={theme} className="comment" neutral={false}
          onClick={this.onLike}
          style={{ color: like && 'red' || 'gray'}}
          label={like ? likeConfig && likeConfig[like.like_type].label : t('label:いいね')} />
      </div>
        <Button theme={theme} className="comment" neutral={false}
          onClick={onComment}
          label={t('label:返信')} />
        <Button theme={theme} className="comment" neutral={false}
          onClick={onStamp}
          label={t('label:スタンプ')} /> 
      </CardText>}
    </div>
    )
  }
}

export default connect(DiaryActions)



// WEBPACK FOOTER //
// ./src/web/components/diary-actions.jsx